import * as React from 'react';
import {
    Popup,
} from 'react-map-gl';
import {toTitleCase} from "../../utils/utils";

function GenericLineLayerPopup({popupData, popupDataSetter}) {

    return (
        <Popup
            longitude={popupData.longitude}
            latitude={popupData.latitude}
            anchor="bottom-right"
            style={{paddingBottom: '5px', paddingRight: '5px'}}
            onClose={() => popupDataSetter(null)}
            closeOnClick={false}
            maxWidth={'auto'}
        >
            <strong style={{'fontSize': '1rem'}}>
                {/*{toTitleCase(popupData.title)}*/}
                {popupData.title}
            </strong>
            <hr className={'mb-1 mt-1'}/>
            <div>
                Longitude: {popupData.longitude}
            </div>
            <div>
                Latitude: {popupData.latitude}
            </div>
            <hr className={'mb-1 mt-1'}/>
            {Object.keys(popupData.attrDict).length > 0 ?
                Object.entries(popupData.properties).map(
                    ([k, v]) =>
                        (Object.keys(popupData.attrDict).includes(k))
                        && popupData.attrDict[k].replace(' ', '') !== ''
                        &&
                        <div key={k}>
                            <strong>{popupData.attrDict[k]}: </strong>
                            {v}
                        </div>
                ) :
                Object.entries(popupData.properties).map(
                    ([k, v]) =>
                        <div key={k}>
                            <strong>{k}: </strong>
                            {v}
                        </div>
                )
            }
        </Popup>)
}

export default React.memo(GenericLineLayerPopup);
